import { useAuth } from "../contexts/authContext";
import { isPartnerTermsGated } from "../lib/partnerTerms";

/**
 * Whether the signed-in user can reach the audit surface the Optro import
 * trackers belong to: the workspace has audit enabled and the user is past
 * the Partner terms gate, and the subscription isn't inactive. Mirrors what
 * RequireAuthAndAuditEnabled checks (the backend answers 403 to workspace
 * calls otherwise), so a tracker mounted above every route stays idle on
 * /accept-terms, in extraction-only workspaces and for inactive
 * subscriptions.
 */
export function useOptroImportAvailable(): boolean {
  const { workspace, workspaceMember } = useAuth();
  return (
    workspace?.auditEnabled === true &&
    workspace.subscriptionStatus !== "Inactive" &&
    !isPartnerTermsGated(workspace, workspaceMember)
  );
}
